import { ActionIcon, Group, Progress, Stack, Text } from "@mantine/core";

import { getAvatar } from "../../utils";

import { TextSerif } from "@/components/elements";
import { IconX } from "@/components/icons";

import type { FileWithPath } from "@mantine/dropzone";
import type { FC } from "react";

export type FileUploadedItemLabels = {
  itemUploading?: string;
  itemWaiting?: string;
};

export type FileUploadedItemProps = {
  disabled?: boolean;
  file: FileWithPath;
  labels?: FileUploadedItemLabels;
  onDelete?: () => void;
  progress?: number;
};

const defaultLabels: FileUploadedItemLabels = {
  itemUploading: "Uploading in progress",
  itemWaiting: "Ready to upload",
};

export const FileUploadedItem: FC<FileUploadedItemProps> = ({
  disabled = false,
  file,
  labels: customLabels,
  onDelete,
  progress = 0,
}) => {
  const labels = { ...defaultLabels, ...customLabels };

  return (
    <Group gap="lg" wrap="nowrap" flex={1}>
      {getAvatar(file.type, URL.createObjectURL(file))}
      <Stack gap="xs" flex={1}>
        <Group justify="space-between" wrap="nowrap">
          <Text size="lg" lh={1} title={file.name} truncate maw={400}>
            {file.name}
          </Text>
          <TextSerif size="sm" style={{ whiteSpace: "nowrap" }}>
            {progress ? labels.itemUploading : labels.itemWaiting}
          </TextSerif>
        </Group>
        <Progress value={progress * 100} />
      </Stack>
      {onDelete && (
        <ActionIcon color="red" variant="light" onClick={onDelete} disabled={disabled}>
          <IconX />
        </ActionIcon>
      )}
    </Group>
  );
};
